<section class="stepper-form">
    <div class="top-stepper">
        <div class="top-left">
            <div class="left-side">
                <a (click)="getRoute()">
                  <img class="main-logo" [src]="getImagePath+'logo.svg'" alt="Rio Logo" width="40px" height="auto">
                </a>
                <!-- <button class="btn toggle-icon d-block d-lg-none" type="button" data-bs-toggle="offcanvas"
                  data-bs-target="#sideMenu" aria-controls="sideMenu">
                  <img class="icon" [src]="getImagePath+'menu-icon.svg'" alt="menu">
                </button> -->                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
              </div>
              <div>
                <div class="new-test d-flex align-items-center">
                    <div class="text-wrap-dot-stepper">{{projects.vProjectName}}</div>
                    <!-- <button type="button" class="bg-transparent border-0" data-bs-toggle="modal"
                        data-bs-target="#editProjectForm" (click)="callApiBasedOnProjectType(projectID)"><img class="logo"
                            [src]="getImagePath+'edit-stepper.svg'" alt="Logo" width="16px" height="16px"></button> -->
                    <button type="button" class="bg-transparent border-0"
                        (click)="EditProjectDetailsModal(editprojectdetails)"><img class="logo"
                            [src]="getImagePath+'edit-stepper.svg'" alt="Logo" width="16px" height="16px"></button>
                </div>
                <div class="text-wrap-dot-stepper short-desc">{{projects.vDescription}}</div>
              </div>
        </div>
        <div class="stepper-section"> 
            <mat-horizontal-stepper [linear]="isLinear" labelPosition="bottom" #stepper class="matHorizontalStepper" [ngClass]="{'on-final-step': isOnFinalStep}"
                (selectionChange)="updateStepContent($event.selectedIndex)" [(selectedIndex)]="activeStepIndex">
                <ng-template matStepperIcon="edit">
                    <mat-icon>radio_button_checked</mat-icon>
                </ng-template>
                <!-- Upload Files -->
                <mat-step [completed]="getStatus(0).completed" aria-disabled="false" [editable]="!isOnFinalStep">
                    <ng-template matStepLabel>
                        <div class="stepLabel" [ngClass]="getStatus(0).className">
                            <div class="label-status-one"> Upload Files</div>
                            <div id="label-status-two-0" class="label-status-two" [ngClass]="getStatus(0).className">{{
                                getStatus(0).status }}</div>
                        </div>
                    </ng-template>
                    <ng-template #step1Content>
                        <app-upload-files [projectType]="projectType" (nextStep)="navigateToStep(1)" (skipStep)="skipToDesignView()"></app-upload-files>
                    </ng-template>
                </mat-step> 
                <!-- Design View -->
                <mat-step [completed]="getStatus(1).completed" [editable]="!isOnFinalStep">
                    <ng-template matStepLabel>
                        <div class="stepLabel" [ngClass]="getStatus(1).className">
                            <div class="label-status-one"> Design View</div>
                            <div id="label-status-two-1" class="label-status-two" [ngClass]="getStatus(1).className">{{
                                getStatus(1).status }}</div>
                        </div>
                    </ng-template>

                    <ng-template #step2Content>
                        <app-design-view (nextStep)="navigateToStep(2)"></app-design-view>
                    </ng-template>
                </mat-step>
                <!-- Specifications -->
                <mat-step [completed]="getStatus(2).completed" [editable]="!isOnFinalStep">
                    <ng-template matStepLabel>
                        <div class="stepLabel" [ngClass]="getStatus(2).className">
                            <div class="label-status-one"> Specifications</div>
                            <div id="label-status-two-2" class="label-status-two" [ngClass]="getStatus(2).className">{{
                                getStatus(2).status }}</div>
                        </div>
                    </ng-template>
                    <ng-template #step3Content>
                        <app-specifications (nextStep)="navigateToStep(3)" class="w-100"></app-specifications>
                    </ng-template>
                </mat-step>
                <!-- BoM Validation -->
                <mat-step [completed]="getStatus(3).completed" [editable]="!isOnFinalStep">
                    <ng-template matStepLabel>
                        <div class="stepLabel" [ngClass]="getStatus(3).className">
                            <div class="label-status-one"> BoM Validation</div>
                            <div id="label-status-two-3" class="label-status-two" [ngClass]="getStatus(3).className">{{
                                getStatus(3).status }}</div>
                        </div>
                    </ng-template>
                    <ng-template #step4Content>
                        <app-bom-upload (nextStep)="navigateToStep(4)" class="w-100"></app-bom-upload>

                    </ng-template>
                </mat-step>
                <!-- Quotation & Order -->
                <mat-step [completed]="getStatus(4).completed">
                    <ng-template matStepLabel>
                        <div class="stepLabel" [ngClass]="getStatus(4).className">
                            <div class="label-status-one"> Quotation & Order</div>
                            <div id="label-status-two-4" class="label-status-two" [ngClass]="getStatus(4).className">{{
                                getStatus(4).status }}</div>
                        </div>
                    </ng-template>
                    <ng-template #step5Content>
                        <app-quotation-and-order class="w-100"></app-quotation-and-order>

                    </ng-template>
                </mat-step>
            </mat-horizontal-stepper>
        </div>
        <div class="right-width">
            <div *ngIf="isStepperFormsRoute()" class="right-side">
                <div class="profile-btn" [matMenuTriggerFor]="profilemenu">
                  <div class="mx-2">
                    <img [src]="userDetails?.vProfilePhoto || getImagePath + 'avatar.svg'" alt="user" class="avatar" />
                  </div>
                  <div class="align-items-center">
                    <p class="user-name cursor-pointer">{{ userDetails?.vName }}</p>
                  </div>
                  <mat-menu #profilemenu="matMenu" class="header-matmenu header-matmenu_box">
                    <!-- <button mat-menu-item [routerLink]="['/customer/profile']">Profile</button> -->
                    <button mat-menu-item (click)="ChangePassword()">Change Password</button>
                    <button mat-menu-item (click)="HandleLogout()">Sign Out</button>
                  </mat-menu>
                </div>
              </div>
        </div>
        
    </div>
    <div class="stepper-content ">
        <ng-container [ngSwitch]="stepContent">
            <ng-container *ngSwitchCase="'content-1'">
                <ng-container *ngTemplateOutlet="step1Content"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'content-2'">
                <ng-container *ngTemplateOutlet="step2Content"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'content-3'">
                <ng-container *ngTemplateOutlet="step3Content"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'content-4'">
                <ng-container *ngTemplateOutlet="step4Content"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'content-5'">
                <ng-container *ngTemplateOutlet="step5Content"></ng-container>
            </ng-container>
        </ng-container>
    </div>
</section>

<!-- Edit Contact modal -->
<ng-template #editprojectdetails let-c="close" let-d="dismiss">
    <div class="modal-dialog modal-dialog-centered m-0">
        <div class="edit-project-dialog modal-content">
            <div class="d-flex flex-column align-items-center relative">
                <img class="logo" [src]="getImagePath+'edit-project.svg'" alt="Logo" height="40" width="40">
                <div class="improved-page-label">Edit Project Details</div>
                <button type="button" class="close-btn btn" aria-label="Close" (click)="d('Cross click')">
                    <img [src]="getImagePath+'close-icon.svg'" alt="Close" height="15" width="15">
                </button>
            </div>
            <div class="form-container">
                <form class="custom-create-project-form" id="editProjectForm" [formGroup]="editProjectForm" (ngSubmit)="EditProject()">
                    <div class="form-control-box bottom-spacing">
                        <label for="vProjectName" class="label">Project Name<span class="text-danger">*</span></label>
                        <div>
                            <mat-form-field appearance="outline" class="improved-input w-100">
                              <input matInput id="name" placeholder="Enter Project Name" formControlName="vProjectName"
                              (input)="CheckIfInvalid()">
                            </mat-form-field>
                          </div>
                          <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                          class="input-details-box no-mat-input justify-content-end">
                          <mat-error class="w-100 increase-z-index error-top-spacing error-message"
                            *ngIf="hasError(editProjectForm, 'vProjectName', 'required')">
                            Project Name is required.
                          </mat-error>
                          <mat-error class="w-100 increase-z-index error-top-spacing error-message"
                            *ngIf="hasError(editProjectForm, 'vProjectName', 'maxlength')">
                            Must not exceed 100 characters.
                          </mat-error>
                          <mat-error class="w-100 increase-z-index error-top-spacing error-message"
                            *ngIf="hasError(editProjectForm, 'vProjectName', 'pattern')">
                            Please enter valid name.
                          </mat-error>
                        </div>
                    </div>
                    <div class="form-control-box bottom-spacing">
                        <label for="vDescription" class="label">Description<span class="text-danger">*</span></label>
                        <div>
                            <mat-form-field appearance="outline" class="improved-textarea ">
                              <textarea matInput rows="5" cdkTextareaAutosize id="description" placeholder="Write Description"
                              formControlName="vDescription" (input)="CheckIfInvalid()" #input></textarea>
                          </mat-form-field>
                          </div>
                          <div name="input-details-box-company-phone-number" id="input-details-box-company-phone-number"
                          class="input-details-box no-mat-input justify-content-end">
                          <mat-error class="w-100 increase-z-index error-top-spacing error-message"
                            *ngIf="hasError(editProjectForm, 'vDescription', 'required')">
                            Project Description is required!
                          </mat-error>
                          <mat-error class="w-100 increase-z-index error-top-spacing error-message"
                            *ngIf="hasError(editProjectForm, 'vDescription', 'maxlength')">
                            Must not exceed 1000 characters!
                          </mat-error>
                          <mat-error class="w-100 increase-z-index error-top-spacing error-message"
                            *ngIf="hasError(editProjectForm, 'vDescription', 'pattern')">
                            Please enter valid name.
                          </mat-error>
                        </div>
                    </div>
                    <div class="w-100 d-flex justify-content-end mt-3"> 
                        <button class="btn btn-primary improved-add-btn" [disabled]="!editProjectForm.dirty || editProjectForm.invalid"
                            [ngClass]="{'disabled-button': !editProjectForm.dirty || editProjectForm.invalid}" (onClick)="EditProject()">Update</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</ng-template>